import Fire_base from '../../../Config/Fire_base'

const UpdatePhotoProfile =  async (state) => {
    const currentUser = Fire_base.auth().currentUser
    let setReturn = {}
    console.log(currentUser.photoURL)
    if(currentUser.photoURL === null){
        await Fire_base.storage().ref('users/'+currentUser.uid+ '/profile.jpg').put(state).then((res)=>{
            currentUser.updateProfile({
                photoURL: res.ref.fullPath
            })
            console.log(res)
            setReturn=res 
        })
    }
    else{
        
        await Fire_base.storage().ref(currentUser.photoURL).delete()
        await Fire_base.storage().ref('users/'+currentUser.uid+ '/profile.jpg').put(state).then((res)=>{
            currentUser.updateProfile({
                photoURL: res.ref.fullPath
            })
            console.log(res)
            setReturn=res 
        })
    }

    return setReturn

}

export default UpdatePhotoProfile